import { render } from "./AntdApp.vue?vue&type=template&id=50c9ea71&ts=true"
import script from "./AntdApp.vue?vue&type=script&lang=ts"
export * from "./AntdApp.vue?vue&type=script&lang=ts"

import "./AntdApp.vue?vue&type=style&index=0&id=50c9ea71&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__